import React from 'react';
import Payments from '@/features/payments/manage/components/Payments';

const EmergePayments = () => <Payments showBreadcrumbs={false} showMoveMoney />;

export default EmergePayments;
